<ul>
    <li *ngFor="let webhook of webhooks$ | async; trackBy: trackByFn">
        <mat-card>
            <mat-card-content>
                <app-webhook-editor [webhook]="webhook"></app-webhook-editor>
                <mat-card-actions align="end">
                    <button mat-button (click)="delete(webhook)">
                        <span>Delete</span>
                        <mat-icon>delete</mat-icon>
                    </button>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>
    </li>
    <li class="new">
        <mat-card>
            <mat-card-title>
                <span>New Webhook</span> 
                <mat-icon>create</mat-icon>
            </mat-card-title>
            <mat-card-content>
                <app-webhook-editor [webhook]="{}"></app-webhook-editor>
            </mat-card-content>
        </mat-card>
    </li>
</ul>